import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

export const Layout = ({ children, location }) => {
    return (
        <>
            <Header props={location} />
            <div id="skip">{children}</div>
            <Footer props={location} />
        </>
    );
};
